export const lightThemeColors = {
  darkColor: "rgba(37, 34, 34, 1)",

  darkColorFaded: "rgba(37, 34, 34, 0.7)",
  lightColor: "rgba(255,255,255,1)",
  lightColorFaded: "rgba(255,255,255,0.9)",
  lightColorFaded7: "rgba(255, 255, 255, 0.7)",
  lightColorFaded2: "rgba(255, 255, 255, 0.2)",

  darkColorFullFaded: "rgba(47, 47, 47, 0.1)",
  primaryColor: "rgba(42, 134, 255, 1)",
  primaryColorFaded: "rgba(42, 134, 255, 0.3)",
  background: "rgba(255, 255, 255, 1)",
  fold1Bg: "rgba(244, 249, 255, 1)",
  footerBg: "rgba(0, 0, 0, 1)",
  borderColor: "rgba(0, 0, 0, 0.1)",
  cardBg: "rgba(239, 242, 245, 1)",
  validGreen: "rgba(112, 203, 151, 1)",
  validGreenFaded: "rgba(112, 203, 151, 0.2)",
  inputFieldBorder: "rgba(19, 36, 65, 0.1)",
  labelColor: "rgba(118, 114, 113, 0.6)",
  textColor: "rgba(118, 114, 113, 1)",
  linkGeneratorBg: "rgba(246, 244, 242, 1)",
  inputFieldLabelColor: "rgba(120, 118, 118, 1)",
  cardBgDark: "rgba(52, 52, 51, 1)",
  cardTextColorDark: "rgba(255, 255, 255, 0.5)",
  darkBannerBg: "rgba(36, 36, 36, 1)",

  socialMediaPreviewCard: {
    buttonBg: "rgba(42, 134, 255, 0.03)",
    buttonBgSelected: "rgba(227, 237, 249, 1)",
    secondColor: "rgba(96, 103, 112, 1)",
    primaryColor: "rgba(29, 33, 41, 1)",
    xCardInfoBg: "rgba(242, 243, 245, 1)",
    xCardDomainColor: "rgba(181, 185, 190, 1)",
  },


  landingPagePrimaryBackground: "rgba(25, 34, 74, 1)",
  dropDownBackgroundClosed: "rgba(246, 244, 242, 1)",
  dropDownBackgroundOpen: "rgba(36, 36, 36, 1)",
  darkBlue: "rgba(21, 49, 91, 1)",
  crossAppMessagingBg: "rgba(66, 0, 0, 1)",
  engagementBg: "rgba(8, 36, 41, 1)",
  measureBg: "rgba(25, 34, 74, 1)",
  analyseBg: "rgba(39, 16, 60, 1)",
  marketingBg: "rgba(76, 31, 61, 1)",

  howWorkCardBg: "rgba(46, 45, 45, 1)",
  getStartedRequestDemoBackground: "rgba(249, 247, 246, 1)",

  header: {
    menuItemColor: "rgba(255, 255, 255, 1)",
    menuItemColorFaded: "rgba(255, 255, 255, 0.8)",
    absoluteBlack: "rgba(0, 0, 0, 1)",
    categoryTypeColor: "rgba(77, 77, 77, 1)"
  }


};
